import styled from "styled-components"

import { maxWidth } from "utils"

export const StyledToastsContainer = styled.div`
  position: fixed;
  display: block;
  bottom: 2rem;
  left: 2rem;
  width: 26rem;
  z-index: 9999;

  ${maxWidth.hamburgerLarge`
    display:none;
  `}
`

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  padding: 0;
`

export const TooltipContent = styled.div`
  display: ${({ visible }) => (visible ? "block" : "none")};
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.8rem;
  border-radius: 1rem;
  z-index: 1;
  top: -4rem;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 1.4rem;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out; /* Add transition for opacity */

  ${maxWidth.hamburgerLarge`
    display: none;
  `}
`

export const StyledToast = styled.div`
  width: 100%;
  display: flex;
  border-radius: 1.2rem;
  background: #fff;
  padding: 2rem 3.5rem 2rem 2.5rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  border-left: 6px solid ${(props) => props.theme.colors.primary};
  overflow: hidden;
  margin-bottom: 1.5rem;
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.35);
`

export const ToastContent = styled.div`
  display: flex;
  align-items: center;
`

// Styled icon
export const ToastIcon = styled.span`
  font-size: 2.4rem;
  background-color: red;
  margin-right: 1rem;
`

// Styled message
export const ToastMessage = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 2rem;
`

export const ToastText = styled.div`
  font-size: 1.6rem;
  font-weight: 400;
  color: #666666;
`

// Styled dismiss button
export const DismissButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 1.6rem;
  cursor: pointer;
  outline: none;
  padding: 0;
`
